import React, { useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import FormHeader from '../components/Header'
import OTPInput from './OtpInput'
import PasswordStrengthMeter from './PasswordStrengthMeter'
import { useForgotPasswordMutation, useResetPasswordMutation, useVerifyOTPMutation } from '../redux/api/authApi'
import { HiEye } from 'react-icons/hi2'
import { HiEyeSlash } from 'react-icons/hi2'
import { MdEdit } from 'react-icons/md'
import { NavLink } from 'react-router-dom'
import { HiMiniArrowLongLeft } from 'react-icons/hi2'

const ForgotPassword = () => {
  const [otpValue, setOTPValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState(null)
  const [step, setStep] = useState(1)
  const [isOtp, setisOtpCheck] = useState()
  const [passwordError, setPasswordError] = useState('')
  const [newpasswordError, setnewPasswordError] = useState('')

  const [passwordVisible, setPasswordVisible] = useState(false)
  const [emailCheck, setemailCheck] = useState(false)

  const [userValues, setUserValues] = useState({
    email: '',
    newPassword: '',
    confirmPassword: '',
  })

  const [forgotPassword] = useForgotPasswordMutation()
  const [verifyOTP] = useVerifyOTPMutation()
  const [resetPassword] = useResetPasswordMutation()

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    switch (step) {
      case 1:
        sendOTP()
        break
      case 2:
        handleVerifyOTP()
        break
      case 3:
        handleResetPassword()
        break
      default:
        break
    }
  }

  const handleChange = (e) => {
    setisOtpCheck('')
    setPasswordError('')
    setnewPasswordError('')
    setErr('')
    setemailCheck(' ')
    const { name, value } = e.target
    setUserValues({ ...userValues, [name]: value })
  }

  const sendOTP = async () => {
    if (!userValues.email) {
      setemailCheck('Please enter required field')
      return
    }
    setLoading(true)

    try {
      const data = await forgotPassword({ email: userValues.email }).unwrap()
      if (data.status === 200) {
        setStep(2)
      } else {
        setErr(data.error)
      }
    } catch (error) {
      setErr(error.data.error)
    } finally {
      setLoading(false)
    }
  }

  const handleVerifyOTP = async () => {
    if (!otpValue) {
      setisOtpCheck('Please enter O.T.P')
      return
    }
    setLoading(true)

    try {
      const data = await verifyOTP({ email: userValues.email, otp: otpValue }).unwrap()
      if (data.Status == 200) {
        setStep(3)
      } else {
        setisOtpCheck('Please enter valid otp')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleResetPassword = async () => {
    if (userValues.newPassword == '') {
      setnewPasswordError('Please enter required field')
      return
    }
    if (userValues.confirmPassword == '') {
      setPasswordError('Please enter required field')
      return
    }
    if (userValues.newPassword !== userValues.confirmPassword) {
      setPasswordError('Passwords do not match')
      return
    }

    setLoading(true)
    try {
      const data = await resetPassword({ email: userValues.email, password: userValues.newPassword }).unwrap()
      if (data.status === 200) {
        alert('Password set Successfully')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleOTPChange = (value) => {
    setisOtpCheck('')
    setOTPValue(value)
  }

  const renderForm = () => {
    switch (step) {
      case 1:
        return (
          <>
            <Form.Group controlId='username' className='form-inputs'>
              <p>Please enter your registered email</p>
              <Form.Label className='m-0'>Email</Form.Label>
              <Form.Control type='text' placeholder='example@mail.com' name='email' value={userValues.email} onChange={handleChange} required />
              {emailCheck && <p className='text-danger'>{emailCheck}</p>}
              {err && <p className='text-danger'>{err}</p>}
            </Form.Group>
          </>
        )
      case 2:
        return (
          <>
            <Form.Group controlId='username' className='form-inputs'>
              <p>Please enter the OTP sent to your email</p>
              <div className='d-flex justify-content-between mt-4'>
                <p className='text-black m-0'>{userValues.email}</p>{' '}
                <button className='border-0 bg-transparent' onClick={() => setStep(1)} style={{ color: '#6BC3BA' }}>
                  <MdEdit /> Change Email
                </button>
              </div>
              <OTPInput length={6} onOTPChange={handleOTPChange} resendOtp={sendOTP} />
              <p type='invalid' className='text-danger text-center'>
                {isOtp}
              </p>
            </Form.Group>
          </>
        )
      case 3:
        return (
          <>
            <Form.Group controlId='New Password' className='forcm-inputs'>
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='New Password'
                name='newPassword'
                value={userValues.newPassword}
                maxLength='30'
                onChange={handleChange}
                required
              />
              {newpasswordError && <p className='text-danger'>{newpasswordError}</p>}
              <PasswordStrengthMeter password={userValues.newPassword} />
            </Form.Group>
            <Form.Group controlId='Confirm Password' className='form-inputs position-relative'>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type={passwordVisible ? 'text' : 'password'}
                placeholder='Confirm Password'
                name='confirmPassword'
                value={userValues.confirmPassword}
                maxLength='30'
                onChange={handleChange}
                required
              />
              <button type='button' className='password-toggle-btn small bg-transparent' onClick={togglePasswordVisibility}>
                {passwordVisible ? <HiEye size={24} /> : <HiEyeSlash size={24} />}
              </button>

              {passwordError && <p className='text-danger'>{passwordError}</p>}
              <a href='#' className='small' onClick={() => setStep(1)}>
                Change Email?
              </a>
              <Form.Control.Feedback type='invalid'>Please enter required field.</Form.Control.Feedback>
            </Form.Group>
          </>
        )
      default:
        return null
    }
  }

  return (
    <>
      <FormHeader />
      <main>
        <section className='login-form-section mt-5'>
          <Container>
            <Row>
              <Col md={6} className='o-1 m-auto login-form-container parent-container'>
                <Form noValidate onSubmit={handleSubmit}>
                  <h3>Forgot Password</h3>
                  {renderForm()}
                  <Button variant='primary' className='common-btn full-btn mt-2' type='submit' disabled={loading}>
                    {loading ? (
                      <div className='d-flex align-items-center justify-content-center gap-2'>
                        <Spinner animation='border' />
                        Loading...
                      </div>
                    ) : (
                      'Continue'
                    )}
                  </Button>
                </Form>
                <NavLink to={'/login'} className='d-flex align-items-center justify-content-center m-0 mt-2 '>
                  <HiMiniArrowLongLeft className='me-1' />
                  Back to login
                </NavLink>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  )
}

export default ForgotPassword
